import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { Profile } from '../../@types/Profile';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import useBranch from '../branch/useBranch';

export const PROFILE_QUERY = '/api/user/profile';

const useProfile = (): [Profile | undefined, RequestStateQuery] => {
  const [branch] = useBranch();
  const { getToken } = useAuth();

  const { data, isPending, isSuccess, isError } = useQuery<ApiResponse<Profile>>({
    queryKey: [PROFILE_QUERY, branch?.id],
    queryFn: async () => await getJSON<ApiResponse<Profile>>('/api/user/profile', getToken()!),
    enabled: !!branch?.id,
  });
  return [data?.response, { isLoading: isPending, isSuccess, isError }];
};

export default useProfile;
